import type { RouteRecordRaw } from 'vue-router'

export const publicRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    meta: { requiresAuth: false },
    component: () => import('@/views/LoginView.vue'),
  },
  // Matches the link lab-cloud's invite email sends (createInviteService.ts):
  // `${hostURL}/signup?token=${token}`. Real signup form is MIL-73, still a stub.
  {
    path: '/signup',
    name: 'SignupFromInvite',
    meta: { requiresAuth: false },
    component: () => import('@/views/SignupFromInviteView.vue'),
  },
]
